module.exports = __webpack_public_path__ + "static/media/logo_vertical.f3e80047.svg";